export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/f3ca0b85088a2ff6b3b1c7af1abe445d/33d5a3400b39a85f6a3e281b88da1a84.png"
              alt="Massagistas Online"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-stone-500 text-sm leading-relaxed max-w-sm">
              O portal de referência para encontrar <strong className="text-stone-700">massagistas em Curitiba</strong> e Região Metropolitana. Profissionais verificadas, atendimento discreto e de qualidade.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://classivip.com/massagistas"
                target="_blank"
                rel="nofollow noopener"
                className="inline-flex items-center gap-2 bg-rose-400 hover:bg-rose-500 text-white text-xs font-semibold px-4 py-2 rounded-full transition-colors whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                Acessar classivip.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-stone-800 font-semibold text-sm mb-4">Serviços</h4>
            <ul className="space-y-2.5">
              {[
                "Massagem Relaxante Curitiba",
                "Massagem Tântrica Curitiba",
                "Massagem Terapêutica",
                "Massagem com Local",
                "Shiatsu em Curitiba",
              ].map((s, i) => (
                <li key={i}>
                  <a
                    href="https://classivip.com/massagistas"
                    target="_blank"
                    rel="nofollow noopener"
                    className="text-stone-500 hover:text-rose-400 text-sm transition-colors"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-stone-800 font-semibold text-sm mb-4">Regiões</h4>
            <ul className="space-y-2.5">
              {[
                "Batel",
                "Centro",
                "Água Verde",
                "Rebouças",
                "São José dos Pinhais",
                "Colombo",
              ].map((r, i) => (
                <li key={i}>
                  <a
                    href="https://classivip.com/massagistas"
                    target="_blank"
                    rel="nofollow noopener"
                    className="text-stone-500 hover:text-rose-400 text-sm transition-colors"
                  >
                    Massagistas no {r}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-stone-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-400 text-xs">
            &copy; {currentYear} Massagistas.Online – Todos os direitos reservados
          </p>
          <p className="text-stone-400 text-xs">
            Powered by{" "}
            <a
              href="https://classivip.com"
              target="_blank"
              rel="nofollow noopener"
              className="text-rose-400 hover:text-rose-500 transition-colors"
            >
              ClassiVIP
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
